import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Grid } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";

import Dashboard from "../dashboard/dashboard";
import BriefList from "./briefList";

import ContentPanel from "../panels/conentPanel";
import BriefHeader from "./briefHeader";

export default function Brief() {
    const [briefCreatingOpen, setBriefCreatingOpen] = useState(false);

    return (
        <Dashboard>
            <ContentPanel header={<BriefHeader open={briefCreatingOpen} setOpen={setBriefCreatingOpen}/>}>
                <BriefList open={briefCreatingOpen} setOpen={setBriefCreatingOpen} />
            </ContentPanel>
        </Dashboard>
    )
}